module.exports = __webpack_public_path__ + "ecosystem_trial.5307fde5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ecosystem_trial.png
// module id = 243
// module chunks = 0